/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

// You can delete this file if you're not using it

import { wrapRootElement as wrap } from "./wrap-root-element"

export const wrapRootElement = wrap
